import { createSlice } from '@reduxjs/toolkit';
import { admin_apiEndpoint, config_variable } from '../../helper/commonApi';
import { getPriceUpdateAsync, getGoldPurityPriceAsync, createPriceUpdateAsync, createMetafieldDefinitionAsync } from './index';

const initialState = {
    priceUpdateData: null,
    goldPurityPriceData: null,
    isLoading: false,
    isSaving: false,
    isRefreshing: false,
    isError: false,
    isMetafieldDefinitionLoading: false
}

const priceUpdateSlice = createSlice({
    name: 'priceUpdate',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getPriceUpdateAsync.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getPriceUpdateAsync.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                if (payload) {
                    state.priceUpdateData = payload;
                }
            })
            .addCase(getPriceUpdateAsync.rejected, (state) => {
                state.isLoading = false;
                state.isError = false;
                state.priceUpdateData = null;
                if (window.location.hostname !== 'localhost') {
                    window.parent.location.href = `${admin_apiEndpoint}?shop=${config_variable.shop_name}&host=${config_variable?.config.host}`;
                }
            })
            .addCase(getGoldPurityPriceAsync.pending, (state) => {
                state.isRefreshing = true;
            })
            .addCase(getGoldPurityPriceAsync.fulfilled, (state, { payload }) => {
                state.isRefreshing = false;
                if (payload) {
                    state.goldPurityPriceData = payload;
                }
            })
            .addCase(getGoldPurityPriceAsync.rejected, (state) => {
                state.isRefreshing = false;
                state.isError = false;
                state.goldPurityPriceData = null;
                if (window.location.hostname !== 'localhost') {
                    window.parent.location.href = `${admin_apiEndpoint}?shop=${config_variable.shop_name}&host=${config_variable?.config.host}`;
                }
            })
            .addCase(createPriceUpdateAsync.pending, (state) => {
                state.isSaving = true;
            })
            .addCase(createPriceUpdateAsync.fulfilled, (state) => {
                state.isSaving = false;
            })
            .addCase(createPriceUpdateAsync.rejected, (state) => {
                state.isSaving = false;
                state.isError = false;
                state.priceUpdateData = null;
                if (window.location.hostname !== 'localhost') {
                    window.parent.location.href = `${admin_apiEndpoint}?shop=${config_variable.shop_name}&host=${config_variable?.config.host}`;
                }
            })
            .addCase(createMetafieldDefinitionAsync.pending, (state) => {
                state.isMetafieldDefinitionLoading = true;
            })
            .addCase(createMetafieldDefinitionAsync.fulfilled, (state) => {
                state.isMetafieldDefinitionLoading = false;
            })
            .addCase(createMetafieldDefinitionAsync.rejected, (state) => {
                state.isMetafieldDefinitionLoading = false;
                state.isError = false;
                if (window.location.hostname !== 'localhost') {
                    window.parent.location.href = `${admin_apiEndpoint}?shop=${config_variable.shop_name}&host=${config_variable?.config.host}`;
                }
            })
    },
});

export const getAllPriceUpdate = (state) => state.priceUpdate;

export default priceUpdateSlice.reducer;
